
        import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/node_modules/ui-core/plugins/truncate/js/init';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/node_modules/ui-core/components/truncater/js/truncater';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/widgets/table-of-content/js/table-of-content';
  
const main = (UX) => {
    const $truncater = Array.prototype.slice.call(document.getElementsByClassName('js--truncate')),
        $tocJs = Array.prototype.slice.call(document.querySelectorAll('.loa, .meta__authors'))

try {
        if ($truncater.length ) {
            UX.truncater.init($truncater);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($tocJs.length ) {
            UX.tocJs.init($tocJs);
        }
    } catch (err) {
        console.error(err);
    }
    
}

        export default main;
        